<div class="day"
     [class.day--is-today]="dateHelper.isToday(day.date)"
     [class.day--is-disabled]="dateHelper.isPastDay(day.date)">
    <div class="day__header">
        <i class="fa fa-calendar-day mr-2" *ngIf="dateHelper.isToday(day.date)"></i>
        {{ dateHelper.getDayOfWeek(day.date) }} {{ day.date | date:'dd.MM.' }}
    </div>

    <div class="day__shifts">
        <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn; let i = index">
            {{ shiftHelper.transformShiftNumber(i) }}
        </div>
    </div>
</div>


